<template>
  <div
    class="VersionNotes"
    :class="open ? 'VersionNotes__open' : ''"
    :style="{ opacity: open ? 1 : 0.6 }"
  >
    <div class="message is-info is-small">
      <div class="message-header">
        {{ versions[0].num }} : notes de version
        <i
          class="fa"
          :class="`fa-caret-${open ? 'up' : 'down'}`"
          style="cursor: pointer;"
          @click="open = !open"
        ></i>
      </div>
      <div class="message-body">
        <version-bar>{{ versions[0].num }}</version-bar>
        <div v-if="versions[0].codename">Nom de code : "{{ versions[0].codename }}"</div>
        <ul>
          <li v-for="(l, index) in versions[0].content" :key="index">
            {{ l }}
          </li>
        </ul>
        <div style="opacity: 0.7;">
          <div v-for="v in versions.slice(1)" :key="v.num">
            <version-bar>{{ v.num }}</version-bar>
            <div v-if="v.codename">Nom de code : {{ v.codename }}</div>
            <ul>
              <li v-for="(l, index) in v.content" :key="index">{{ l }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VersionBar from "./VersionBar";
import versions from "../../versions";

export default {
  name: "version-notes",
  components: { VersionBar },
  data() {
    return {
      versions,
      open: false
    };
  }
};
</script>

<style lang="scss">
.VersionNotes {
  width: 100%;
  max-width: 45ch;
  display: inline-block;
  margin-left: 3ch;
  .message {
    position: relative;
    &-header {
      border-radius: 2px;
      background: rgba(49, 40, 124, 0.7) !important;
      z-index: 2;
    }
    &-body {
      border-radius: 0;
      color: black !important;
      position: absolute;
      top: 2.5em;
      left: 0;
      width: 100%;
      z-index: 1;
      background: white;
      display: none;
      max-height: 90vh;
      overflow: scroll;
    }
  }
  &__open {
    .message {
      &-header {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
      &-body {
        display: block;
        box-shadow: 0 0 10px #0005;
      }
    }
  }
}
</style>
